import React from 'react';
import { Avatar, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/';
import InfoIcon from '@material-ui/icons/Info';
import { useState, useEffect } from 'react';
import { ReactComponent as LowesSvg } from '../../images/lowes.svg';
import { isEmpty, isNil } from 'lodash';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
	sourceAvatar: {
		color: 'white',
		textAlign: 'center',
		fontSize: '1rem',
		'& img': {
			objectFit: 'fill',
		},
		backgroundColor: '#971B2F',
	},
	lowesSvg: {
		'& svg': {
			height: '1em',
		},
		position: 'absolute',
		marginTop: '-0.5em',
	},
	disable: {
		opacity: '0.3',
	},
}));

function ModelRequiredAvatar({ imgUrl, label, toolTipMsg, isProduct, disable }) {
	const classes = useStyles();
	const [titleMsg, settitleMsg] = useState('');
	// disable Lowes.com column (product image) with a tooltip. if its not buyable.
	const avatarRootClasses = classNames({
		[classes.disable]: disable,
	});
	// only render toolTip error message when image loading fails.
	const AltText = () => {
		useEffect(() => {
			settitleMsg(toolTipMsg);
		});
		return (
			<>
				<InfoIcon fontSize="small" color="inherit" />
				{label}
			</>
		);
	};
	// disable and change the tooltip basing on isBuyable status.
	const LowesSvgIcon = () => {
		let msg = '';
		useEffect(() => {
			if (!isEmpty(imgUrl)) {
				settitleMsg(msg);
			}
		}, [msg]);
		if (!isNil(imgUrl) && !isEmpty(imgUrl) && isProduct) {
			if (disable) {
				msg = 'This product is non-buyable on lowes.com';
			} else {
				msg = 'This product is buyable on lowes.com';
			}
			return (
				<div className={classes.lowesSvg}>
					<LowesSvg />
				</div>
			);
		}
		return null;
	};

	return (
		<Tooltip title={titleMsg} arrow={true} placement="top">
			<div className={avatarRootClasses}>
				<Avatar src={imgUrl} variant="square" className={classes.sourceAvatar} disabled={disable}>
					<AltText />
				</Avatar>
				<LowesSvgIcon />
			</div>
		</Tooltip>
	);
}

export default ModelRequiredAvatar;
